import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import { LazyLoadImage } from "react-lazy-load-image-component";

import ConditionalRender from "../../components/Common/ConditionalRender";
import Button from "../../components/Common/Button";
import { useHandleClickLoading } from "../../components/Common/utils";

function ArticleTrendSlider({ data, loading }) {
    const handleClickLoading = useHandleClickLoading();
    return (
        <div className="flex flex-col gap-1 ">
            <div className="flex flex-col h-80 gap-1 px-3">
                <div className="flex flex-col h-full w-full z-10 relative">
                    <ConditionalRender
                        productsData={data}
                        isLoading={loading}
                        model={"emptyData"}
                    >
                        <div className=" absolute top-0 left-0 right-0 bottom-0">
                            <Swiper
                                className="w-full h-full py-2"
                                spaceBetween={10}
                                loop={true}
                                breakpoints={{
                                    0: {
                                        slidesPerView: 1,
                                    },
                                    400: {
                                        slidesPerView: 2,
                                    },
                                    639: {
                                        slidesPerView: 2,
                                    },
                                    865: {
                                        slidesPerView: 3,
                                    },
                                    1000: {
                                        slidesPerView: 3,
                                    },
                                    1500: {
                                        slidesPerView: 3,
                                    },
                                    1700: {
                                        slidesPerView: 4,
                                    },
                                }}
                                modules={[Autoplay]}
                            >
                                {data.map((item, index) => {
                                    return (
                                        <SwiperSlide
                                            key={index}
                                            className="flex flex-col sw-auto"
                                        >
                                            <button
                                                onClick={() => { handleClickLoading('/news/' + item.slug) }}
                                                className="flex flex-1 flex-col h-full w-full relative p-2.5 rounded-lg"
                                                style={{
                                                    backgroundImage: `url(${item.gambar})`,
                                                    backgroundSize: "cover",
                                                    backgroundPosition: "center",
                                                }}>
                                                <div className="absolute inset-0 bg-black opacity-30 rounded-lg"></div>
                                                <div className="flex flex-col w-full z-10 items-start justify-between h-full">
                                                    <div className="flex flex-row justify-end w-full">
                                                        <div className="bg-[#22BDE2] p-1 rounded-tr-lg rounded-bl-lg px-3">
                                                            <span className="text-[#ffffff] text-left text-sm font-light line-clamp-1">
                                                                {item.jenis}
                                                            </span>
                                                        </div>
                                                    </div>
                                                    <div className="flex flex-col gap-1">
                                                        <span className="text-[#ffffff] text-left text-lg font-bold line-clamp-3">
                                                            {item.judul}
                                                        </span>
                                                        <span className="text-[#ffffff] text-left text-sm font-semibold line-clamp-1">
                                                            {item.tanggal}
                                                        </span>
                                                    </div>
                                                </div>
                                            </button>
                                        </SwiperSlide>
                                    );
                                })}
                            </Swiper>
                        </div>
                    </ConditionalRender>
                </div>
            </div>
        </div>
    );
}

export default ArticleTrendSlider;
